var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[((_vm.$route.name === 'login' || _vm.$route.name === 'esqueciSenha'))?_c('div',[_c('v-main',{staticClass:"page-notLogged"},[_c('router-view')],1)],1):_c('div',[_c('v-main',{staticClass:"page-logged"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }